"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'Hero_Carousel_1_0_0',
  slides: [],
  className: '',
  autoplay: false,
  autoplaySpeed: 3000,
  cyclical: false
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;